var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopNewUi = function SvgDesktopNewUi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 18H2.558A1.56 1.56 0 0 1 1 16.441V15h23v1.444c0 .858-.698 1.556-1.556 1.556ZM10 22h5v-3h-5v3ZM2.558 1h19.886C23.302 1 24 1.698 24 2.556V14H1V2.559C1 1.699 1.7 1 2.558 1Zm19.886-1H2.558A2.562 2.562 0 0 0 0 2.559v13.882A2.562 2.562 0 0 0 2.558 19H9v3H7v1h11v-1h-2v-3h6.444A2.559 2.559 0 0 0 25 16.444V2.556A2.559 2.559 0 0 0 22.444 0Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgDesktopNewUi;